import React from 'react';
import classes from "./FrontInfoBox.module.css";

const FrontInfoBox = (props: any) => (
    <div className={classes.FrontInfoBox}>{props.children}</div>
);

export default FrontInfoBox;
